import { connect } from 'react-redux'
import SelectSchool from './select-school'
import {
  getSearchValue,
  getFoundSchools,
  getSearchRequest,
  getSelectedSchool
} from '../redux/fsu-teacher.selectors'
import { showNewSchool } from '../redux/fsu-teacher.actions'

const mapStateToProps = state => ({
  searchPending: getSearchRequest(state).pending,
  showSchoolNotInTheList: getSearchValue(state) && !!getFoundSchools(state),
  selectedSchool: getSelectedSchool(state)
})

const mapDispatchToProps = dispatch => ({
  onShowNewSchool: () => dispatch(showNewSchool())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectSchool)
